<template>
  <div>
    <el-dialog title="关联用户" :visible.sync="visible" width="1300px">
      <el-form :inline="true" size="mini" :model="listQuery" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="listQuery.search_type" placeholder="搜索类型">
            <el-option label="用户昵称" value="1"></el-option>
            <el-option label="手机号" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="listQuery.keyword_search" placeholder="关键字模糊搜索"></el-input>
        </el-form-item>
        <el-form-item label="阶段筛选:">
          <el-select v-model="listQuery.stage_uuid" placeholder="全部">
            <el-option
              v-for="item in stageList"
              :key="item.uuid"
              :label="item.stage_name"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组筛选:">
          <el-select v-model="listQuery.grouping_uuid" placeholder="全部">
            <el-option
              v-for="item in groupList"
              :key="item.uuid"
              :label="item.grouping_name"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签筛选:">
          <el-select v-model="listQuery.label_uuid" placeholder="全部">
            <el-option v-for="item in tagList" :key="item.uuid" :label="item.label_name" :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        v-loading="listLoading"
        :data="rowData"
        @selection-change="changeFun"
        @select="selectMemoryFn"
        @select-all="selectAll"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column property="user_name" label="昵称"></el-table-column>
        <el-table-column property="user_mobile" label="手机"></el-table-column>
        <el-table-column width="200" property="address" label="地址">
          <template slot-scope="scope">
            <span>{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.area }}</span>
          </template>
        </el-table-column>
        <el-table-column property="fans_num" label="用户粉丝数量"></el-table-column>
        <el-table-column property="punch_day_num" label="用户打卡天数"></el-table-column>
        <el-table-column property="like_num" label="用户点赞数量"></el-table-column>
        <el-table-column property="create_time" label="注册时间"></el-table-column>
      </el-table>
      <div class="page">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page_index"
          :limit.sync="listQuery.page_size"
          @pagination="getTableList"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getUserList } from "@/api/user";
import { getGroupList, getTagList, getStageList } from "@/api/stage";
import Pagination from "@/components/Pagination";

function flatDeep(arr, d = 1) {
  return d > 0
    ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), [])
    : arr.slice();
}
function flatten(input) {
  const stack = [...input];
  const res = [];
  while (stack.length) {
    // pop value from stack
    const next = stack.pop();
    if (Array.isArray(next)) {
      // push back array items, won't modify the original input
      stack.push(...next);
    } else {
      res.push(next);
    }
  }
  // reverse to restore input order
  return res.reverse();
}
export default {
  components: { Pagination },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rowData: [],
      dialogFormVisible: false,
      checked: [],
      listQuery: {
        page_index: 1,
        page_size: 10,
        search_type: "",
        stage_uuid: "",
        grouping_uuid: "",
        label_uuid: "",
        keyword_search: "",
        data_type: 1,
      },
      stageList: [],
      tagList: [],
      groupList: [],
      total: 0,
      listLoading: false,
      multipleSelection: [],
      ids: [],
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getTableList();
        this.getStageList();
        this.getTagList();
        this.getGroupList();
      }
    },
    rowData(oldVal, newVal) {
      // 监听数据变化，然后执行分页记忆自动选中回调
      this.$nextTick(() => {
        this.selectMemoriedDataFn();
      });
    },
  },
  methods: {
    onOk() {
      const selectedListId = this.selectedList.map((i) => i.uuid);
      const selectList = flatten(this.multipleSelection).filter((i) => i);
      console.log("selectList", selectList);
      const addList = selectList.filter((i) => {
        return !selectedListId.includes(i.uuid);
      });
      this.$emit("onOk", [...addList, ...this.selectedList]);
      this.multipleSelection = [];
      this.listQuery.page_index = 1;
      this.$emit("onCancel");
    },
    onCancel() {
      this.$emit("onCancel");
    },
    async getStageList() {
      const list = await getStageList({ data_type: 2 });
      this.stageList = [{ uuid: "", stage_name: "全部" }, ...list];
    },
    async getTagList() {
      const list = await getTagList({ data_type: 2 });
      this.tagList = [{ uuid: "", label_name: "全部" }, ...list];
    },
    async getGroupList() {
      const list = await getGroupList({ data_type: 2 });
      this.groupList = [{ uuid: "", grouping_name: "全部" }, ...list];
    },
    async getTableList(params = this.listQuery) {
      this.listLoading = true;
      const { page_index, page_size } = params;
      this.listQuery.page_index = page_index;
      this.listQuery.page_size = page_size;
      const data = { ...this.listQuery, ...params };
      const res = await getUserList(data);
      this.listLoading = false;
      this.total = res.total;
      this.rowData = res.data;
    },
    search() {
      this.getTableList();
    },
    changeFun(val) {
      // 保存已选数据id到数组，供后续操作（与分页记忆无关）
      this.$nextTick(() => {
        const ids = [];
        this.multipleSelection.forEach((L) => L.forEach((M) => ids.push(M.uuid)));
        this.ids = ids;
      });
    },
    selectAll(selection) {
      // 全选切换方法
      if (selection.length) {
        // 全选
        this.multipleSelection[this.listQuery.page_index - 1] = selection;
      } else {
        // 全不选
        this.multipleSelection[this.listQuery.page_index - 1] = [];
      }
    },
    selectMemoryFn(val, row) {
      console.log(111);
      // 设置分页记忆二位数组方法
      // 注意：val 传过来默认为数组类型 ，row 为 Object（当前选择数据对象）
      const currentArr = this.multipleSelection[this.listQuery.page_index - 1]; // 当前分页对应数组
      if (!currentArr) {
        this.multipleSelection[this.listQuery.page_index - 1] = val; // 不存在这个二维数组，则创建这个二位数组
      } else {
        // 存在
        if (val.includes(row)) {
          // 选中
          this.multipleSelection[this.listQuery.page_index - 1] = val;
        } else {
          // 取消
          delete currentArr[currentArr.indexOf(row)];
        }
      }
    },
    selectMemoriedDataFn() {
      // 分页记忆自动选中方法
      const currentArr = this.multipleSelection[this.listQuery.page_index - 1]; // 当前分页对应被选中数据
      if (currentArr && currentArr.length) {
        // 存在则继续执行
        const tempRowsIDs = this.rowData.map((L) => L.uuid); // 当前分页被选中数据的id集合
        currentArr.forEach((item, index) => {
          // 遍历当前分页被选中数据
          if (tempRowsIDs.includes(item.uuid)) {
            // id匹配上，则选中
            this.$refs.multipleTable.toggleRowSelection(this.rowData[tempRowsIDs.indexOf(item.uuid)]);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
